// extracted by mini-css-extract-plugin
module.exports = {"comp":"G_comp__bsVEW"};